module.exports = __webpack_public_path__ + "img/njklogo.dedaacd3.png";